import { NotFoundError } from '@shared/api/errors/errors';
import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import type { AuditLogEventDto } from '@shared/api/contracts';
import { mapAuditLogEvent, type AuditLogEvent } from '@entities/audit-log';
import { AUDIT_LOG_SWR_OPTIONS } from './use-audit-log-list';

export function useAuditLogEvent(eventId: string | null, known: AuditLogEvent | null) {
  const shouldFetch = Boolean(eventId) && (!known || known.id !== eventId);
  const { data, error, isLoading } = useSWR<AuditLogEventDto>(
    shouldFetch && eventId ? swrKeys.auditLog.byId(eventId) : null,
    AUDIT_LOG_SWR_OPTIONS
  );

  const event = known && known.id === eventId ? known : data ? mapAuditLogEvent(data) : null;

  return {
    event,
    isLoading: shouldFetch && isLoading,
    notFound: error instanceof NotFoundError,
    error,
  };
}
